import { cardRef, defineGameCard, onResolve, tableTarget } from '../authoring/index.js';
import { plannedTableId } from './slime-helpers.js';
export const SlimefallCard = defineGameCard({
    id: 'slimefall',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: { target: tableTarget({ cardinality: { min: 1, max: 1 } }) },
    },
    presentation: {
        name: 'Слизнепад',
        description: 'Создайте до двух Капель 1/1 в свободных ячейках выбранной локации.',
        glyph: {
            colors: ['#10213A', '#76737A', '#8DB257', '#66646F', '#778A67'],
            rows: [
                '.......111111.......',
                '......12233241......',
                '....114222222411....',
                '...12242222222221...',
                '..1433542225322241..',
                '..1422222222224441..',
                '.144442224444444141.',
                '.141144114444111411.',
                '..1511131111111111..',
                '.3.3......3.....3...',
                '.3...5....3.1.1.3...',
                '.....3......1.......',
                '..5..3...3..4.......',
                '..3..3...3..5.3.....',
                '..3..5...3..5.35....',
                '.........5..3.......',
                '...3....33..3.5..3..',
                '...5.5..33..3.5.3...',
                '.....3..55....3.....',
                '.........4..........',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('slime_droplet')],
    abilities: [onResolve((ctx) => {
            const tableId = plannedTableId(ctx, 'target');
            const controllerId = ctx.self?.controllerId;
            if (tableId === undefined || controllerId === undefined)
                return;
            ctx.ops.createTokenInLocation('slime_droplet', controllerId, tableId);
            ctx.ops.createTokenInLocation('slime_droplet', controllerId, tableId);
        })],
    ui: {
        mechanics: ['token'],
        planning: { steps: { target: { label: 'Выберите локацию' } } },
    },
});
//# sourceMappingURL=slimefall.js.map